import axios from 'api/axios'
import { WabaManagementApiResponse } from 'types'

export interface ConnectedWaba {
	id: string
	type: 'PRIMARY' | 'COEXISTENCE'
	wa_phone_id: string
	wabaId: string
	wa_token?: string | null
	display_phone_number: string
	webhookUrl?: string | null
	webhookToken?: string | null
	adminId?: string
	admin?: { name?: string; email?: string }
	canDeregister: boolean
}

export interface UpdateCoexistenceConnectionPayload {
	wa_token?: string
	wa_phone_id?: string
	wabaId?: string
	display_phone_number?: string
	webhookUrl?: string
	webhookToken?: string
}

export interface GetConnectedWabasResponse {
	connections: ConnectedWaba[]
}

const WabaManagement = {
	getWabaPhoneDetailsForClient: async (clientId: string) => {
		const { data } = await axios.get<WabaManagementApiResponse>(
			`v1/tsp/meta/waba/phone-number/details?clientId=${clientId}`
		)
		return data
	},
	getConnectedWabas: async (clientId: string) => {
		const { data } = await axios.get<GetConnectedWabasResponse>(
			`v1/tsp/meta/waba/connections?clientId=${clientId}`
		)
		return data
	},
	deregisterWaba: async (params: {
		clientId: string
		connectionId?: string
		type?: 'primary'
	}) => {
		const { data } = await axios.post<{ message: string; success: boolean }>(
			'v1/tsp/meta/waba/connection/deregister',
			params
		)
		return data
	},
	resetWaba: async (clientId: string) => {
		const { data } = await axios.post<{ message: string; success: boolean }>(
			`v1/tsp/meta/waba/reset?clientId=${clientId}`
		)
		return data
	},
	deregisterCoexistence: async () => {
		const { data } = await axios.post<{ message: string; success: boolean }>(
			`v1/tsp/meta/coexistence/deregister`
		)
		return data
	},
	updateCoexistenceConnection: async (
		clientId: string,
		connectionId: string,
		payload: UpdateCoexistenceConnectionPayload
	) => {
		const { data } = await axios.put<{
			message: string
			connection: ConnectedWaba
		}>(
			`v1/tsp/meta/waba/connection/${connectionId}?clientId=${clientId}`,
			payload
		)
		return data
	},
	createCoexistenceConnectionForAdmin: async (
		clientId: string,
		adminId: string,
		payload: UpdateCoexistenceConnectionPayload
	) => {
		const { data } = await axios.post<{
			message: string
			connection: ConnectedWaba
		}>(`v1/tsp/meta/waba/connection/for-admin?clientId=${clientId}`, {
			adminId,
			...payload,
		})
		return data
	},
	getCoexistenceConnectionForAdmin: async (
		clientId: string,
		adminId: string
	) => {
		const { data } = await axios.get<{ connection: ConnectedWaba | null }>(
			`v1/tsp/meta/waba/connection/by-admin?clientId=${encodeURIComponent(
				clientId
			)}&adminId=${encodeURIComponent(adminId)}`
		)
		return data
	},
	setupCoexistenceWebhook: async (
		clientId: string,
		payload: {
			connectionId: string
			url?: string
			webhookToken?: string
		}
	) => {
		const { data } = await axios.post<{ message: string }>(
			`v1/tsp/meta/waba/connection/webhook/setup?clientId=${clientId}`,
			payload
		)
		return data
	},
}

export default WabaManagement
